<template>
  <div class="case-box-item">
    <div class="case-list-wrap">
      <swiper :options="swiperOption" ref="caseList">
        <swiper-slide class="case-item">
          <div @mousemove="funStopSwiper" @mouseout="funStartSwiper">
            <img src="../../assets/img/index/case/img_case_index_01.jpg" alt="" class="bg" />
            <div class="first-layer">
              <img src="../../assets/img/index/case/img_logo_case_01.png" alt="" class="log" />
              <dl>
                <dt>紧急运货</dt>
                <dd>解决方案</dd>
              </dl>
            </div>
            <div class="second-layer">
              <dl>
                <dt>紧急运货</dt>
                <dd>解决方案</dd>
              </dl>
              <div class="line"></div>
              <div class="desc">
                “有时节假日仓库爆仓，临时找不到车辆，不仅耽误送货时间，还影响商品周转。”
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="case-item">
          <div @mousemove="funStopSwiper" @mouseout="funStartSwiper">
            <img src="../../assets/img/index/case/img_case_index_02.jpg" alt="" class="bg" />
            <div class="first-layer">
              <img src="../../assets/img/index/case/img_logo_case_02.png" alt="" class="log" />
              <dl>
                <dt>物流配送分散</dt>
                <dd>解决方案</dd>
              </dl>
            </div>
            <div class="second-layer">
              <dl>
                <dt>物流配送分散</dt>
                <dd>解决方案</dd>
              </dl>
              <div class="line"></div>
              <div class="desc">
                “客户需要自提货物到我们各个城市仓，运输效率不理想，且难以实现一站式物流服务体验。”
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="case-item">
          <div @mousemove="funStopSwiper" @mouseout="funStartSwiper">
            <img src="../../assets/img/index/case/img_case_index_03.jpg" alt="" class="bg" />
            <div class="first-layer">
              <img src="../../assets/img/index/case/img_logo_case_03.png" alt="" class="log" />
              <dl>
                <dt>多门店配送</dt>
                <dd>解决方案</dd>
              </dl>
            </div>
            <div class="second-layer">
              <dl>
                <dt>多门店配送</dt>
                <dd>解决方案</dd>
              </dl>
              <div class="line"></div>
              <div class="desc">
                “配送地点多又分散，有些相熟的司机不在发货地，和零散车队合作，价格又不规范。”
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="case-item">
          <div @mousemove="funStopSwiper" @mouseout="funStartSwiper">
            <img src="../../assets/img/index/case/img_case_index_05.jpg" alt="" class="bg" />
            <div class="first-layer">
              <img src="../../assets/img/index/case/img_logo_case_05.png" alt="" class="log" />
              <dl>
                <dt>子母公司用车管控</dt>
                <dd>解决方案</dd>
              </dl>
            </div>
            <div class="second-layer">
              <dl>
                <dt>子母公司用车管控</dt>
                <dd>解决方案</dd>
              </dl>
              <div class="line"></div>
              <div class="desc">
                “全国60多地仓库需要用车，各地员工用车明细难追踪，报销繁琐，费用不透明。”
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="case-item">
          <div @mousemove="funStopSwiper" @mouseout="funStartSwiper">
            <img src="../../assets/img/index/case/img_case_index_06.jpg" alt="" class="bg" />
            <div class="first-layer">
              <img src="../../assets/img/index/case/img_logo_case_06.png" alt="" class="log" />
              <dl>
                <dt>多车型匹配</dt>
                <dd>解决方案</dd>
              </dl>
            </div>
            <div class="second-layer">
              <dl>
                <dt>多车型匹配</dt>
                <dd>解决方案</dd>
              </dl>
              <div class="line"></div>
              <div class="desc">
                “用车城市多且需求不一，很难找到合适的车型，经常无法及时配送，影响客户体验。”
              </div>
            </div>
          </div>
        </swiper-slide>
        <swiper-slide class="case-item">
          <div @mousemove="funStopSwiper" @mouseout="funStartSwiper">
            <img src="../../assets/img/index/case/img_case_index_07.jpg" alt="" class="bg" />
            <div class="first-layer">
              <img src="../../assets/img/index/case/img_logo_case_07.png" alt="" class="log" />
              <dl>
                <dt>货运成本过高</dt>
                <dd>解决方案</dd>
              </dl>
            </div>
            <div class="second-layer">
              <dl>
                <dt>货运成本过高</dt>
                <dd>解决方案</dd>
              </dl>
              <div class="line"></div>
              <div class="desc">
                “每个月的运货量大费用高，导致资金流转慢，不利于公司的快速发展。”
              </div>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>
    <div class="case-ctrl-btn">
      <img
        src="../../assets/img/index/btn_mian_arrow_l@2x.png"
        alt=""
        class="left-btn"
        @click="funSwiperPrev"
      />
      <img
        src="../../assets/img/index/btn_mian_arrow_r@2x.png"
        alt=""
        class="right-btn"
        @click="funSwiperNext"
      />
    </div>
  </div>
</template>

<script>
import 'swiper/dist/css/swiper.css';
import { swiper, swiperSlide } from 'vue-awesome-swiper';

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true, // 环路
        slidesPerView: 5,
        spaceBetween: 0,
        autoplay: true,
        delay: 300,
        speed: 1000,
      },
    };
  },
  computed: {
    caseSwiper() {
      return this.$refs.caseList.swiper;
    },
  },
  mounted() {},
  methods: {
    funStopSwiper() {
      this.caseSwiper.autoplay.stop();
    },
    funStartSwiper() {
      this.caseSwiper.autoplay.start();
    },
    funSwiperPrev() {
      this.caseSwiper.slidePrev();
    },
    funSwiperNext() {
      this.caseSwiper.slideNext();
    },
  },
};
</script>

<style lang="scss" scoped>
.case-box-item {
}
.case-list-wrap {
  width: 100%;
  height: 296px;
  margin-top: 50px;
  overflow: hidden;
}
.case-list {
  position: relative;
  left: 0;
  width: 1680px;
  height: 296px;
  overflow: hidden;
}
.case-item {
  position: relative;
  float: left;
  width: 240px;
  height: 296px;
  .bg {
    position: absolute;
    left: 0;
    top: 0;
    width: 240px;
    height: 296px;
  }
  .first-layer {
    position: relative;
    width: 240px;
    height: 296px;
    background: rgba(0, 0, 0, 0.4);

    .log {
      position: absolute;
      left: 10px;
      top: 10px;
      width: 88px;
      height: 43px;
    }

    dl {
      position: absolute;
      top: 149px;
      width: 240px;
      height: 44px;
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 500;

      dt {
        font-size: 20px;
        margin-bottom: 4px;
      }
    }
  }
  .second-layer {
    display: none;
    position: absolute;
    left: 0;
    top: 0;
    width: 240px;
    height: 296px;
    background: rgba(241, 102, 34, 0.7);
    dl {
      margin-top: 40px;
      width: 100%;
      text-align: center;
      color: #fff;
      font-size: 16px;
      font-weight: 500;

      dt {
        font-size: 20px;
        margin-bottom: 4px;
      }
    }
    .line {
      margin: 15px auto 20px;
      width: 151px;
      height: 1px;
      background: #fff;
    }
    .desc {
      width: 170px;
      margin: 0 auto;
      color: #fff;
      text-align: justify;
    }
    .btn-box {
      position: absolute;
      bottom: 22px;
      left: 50%;
      margin-left: -57px;
      width: 64px;
      height: 16px;
      line-height: 16px;
      padding: 8px 14px 8px 36px;
      border: 1px solid #fff;
      border-radius: 4px;
      color: #fff;
      font-size: 16px;
      &:before {
        content: '';
        position: absolute;
        left: 12px;
        top: 8px;
        width: 16px;
        height: 16px;
        background: url('../../assets/img/index/ic_case_view.png') no-repeat 0 0;
        background-size: 100%;
      }
    }
  }
  &:hover {
    .first-layer {
      display: none;
    }
    .second-layer {
      display: block;
    }
  }
}
.case-ctrl-btn {
  float: right;
  font-size: 0;
  cursor: pointer;
  img {
    width: 48px;
    height: 48px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/index/case.vue